import {parseISO} from "date-fns";

import {GetVehicleHandoversResponse} from "@handover/http-services/responses/get-vehicle-handovers.response";
import {HandoverListItem} from "@handover/view-models/handover-list-item";

export class GetVehicleHandoversResponseMapper {
  mapToHandoverListItem(responses: GetVehicleHandoversResponse[]): HandoverListItem[] {
    const models: HandoverListItem[] = [];

    for (let response of responses) {
      const givenItem = {} as HandoverListItem;
      this.setHandoverItemCommonData(response, givenItem);
      givenItem.isReturn = false;
      givenItem.date = parseISO(response?.BG?.HD);
      givenItem.tokenQR = response?.BG?.QR;

      models.push(givenItem);

      if (response?.ED) {
        const returnItem = {} as HandoverListItem;
        this.setHandoverItemCommonData(response, returnItem);
        returnItem.handoverReturnId = response?.ED.ID;
        returnItem.isReturn = true;
        returnItem.date = parseISO(response?.ED?.HD);
        returnItem.tokenQR = response.ED?.QR;

        models.push(returnItem);
      }
    }

    return models.sort((a, b) => Number(b.date) - Number(a.date));
  }

  private setHandoverItemCommonData(response: GetVehicleHandoversResponse, item: HandoverListItem) {
    item.handoverGivenId = response.ID;
    item.driverFullName = `${response.FN} ${response.LN}`;
    item.initials = `${response.FN[0]}${response.LN[0]}`;
    item.isCreatedOnDesktop = response.BG.QR === "";
  }
}
